import { makeStyles, Theme } from "@material-ui/core";
// Removed unused imports
export const useSuperAdminStyles: any = makeStyles((theme: Theme) => ({
    root: {},
    filtersContainer: {
        display: "grid",
        gridTemplateColumns: "2fr 1fr 2fr 2fr 1fr",
        gap: "30px",
        marginBottom: "20px",
        paddingBottom: "20px",
        borderBottom: "1px dashed #707070",
        backgroundColor: "white",
    },
    formControl: {
        width: "100%",
        "& label": {
            font: "normal normal bold 14px / 19px Roboto",
            letterSpacing: "-0.14px",
            color: "#191919 !important",
            padding: 0,
            marginBottom: "6px",
        },
        "& .MuiOutlinedInput-root": {
            backgroundColor: "#f5f5f5",
        },
        "& .MuiInputBase-root": {
            border: "1px solid #CED4DA",
            height: "32px",
            margin: 0,
            borderRadius: "0px",
            backgroundColor: "transparent",
            "&:before": {
                display: "none",
            },
            "&:after": {
                display: "none",
            },
            "& input": {
                font: "normal normal normal 12px/16px Roboto",
                letterSpacing: "-0.12px",
                color: "#000",
                "&::placeholder": {
                    color: "#7F7F7F",
                },
            },
        },
    },
    tableContainer: {
        backgroundColor: "white",
        boxShadow: "none",
        borderRadius: "0",
        "& tbody td": {
            padding: "10px 15px !important",
            minHeight: "50px",
            font: "normal normal bold 10px/32px Inter",
            letterSpacing: "-0.25px",
            color: "#3C3C3B",
            borderBottom: "1px solid #C0C0C0",
            borderTop: "none",
            borderRight: "1px solid #C0C0C0",
        },
        "& tbody td p": {
            font: "normal normal normal 10px/32px Inter",
            letterSpacing: "-0.25px",
            color: "#3C3C3B",
        },
        "& tbody td:nth-last-child(9)": {
            borderRight: "1px dashed #C0C0C0",
        },
        "& tbody td:last-child": {
            borderRight: "none",
            textAlign: "right",
        },
        "& tbody td:nth-last-child(2)": {
            borderRight: "none",
        },
        "& tfoot td > div": {
            background: "#3C3C3B",
            marginTop: "15px",
            padding: "10px 15px",
            "& > .MuiTablePagination-selectRoot": {
                background: "#FFFFFF",
                border: "1px solid #CED4DA",
                width: "71px",
                height: "32px",
                margin: 0,
                marginLeft: "15px",
                "& > div": {
                    textAlign: "left",
                    textAlignLast: "left",
                    font: "normal normal normal 12px / 55px Inter",
                    letterSpacing: "-0.18px",
                    color: "#191919",
                    height: "32px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    padding: "10px 12px",
                },
            },
            "& .MuiTablePagination-spacer": {
                display: "none",
            },
            "& .MuiTablePagination-caption": {
                font: "normal normal normal 12px/16px Inter",
                letterSpacing: "-0.18px",
                color: "#FFFFFF",
            },
            "& .MuiTablePagination-actions button": {
                background: "#E0E0E0",
                height: "32px",
                width: "32px",
                borderRadius: "2px",
            },
            "& .MuiTablePagination-actions": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                marginLeft: "0",
            },
            "& .MuiInputBase-root + p": {
                padding: "0 10px",
                marginLeft: "auto",
            },
        },
        "tr:has(.MuiIconButton-root:hover)": {
            backgroundColor: "#e0e0e0",
        },
    },
    actionButton: {
        background: "#449B23",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#4caf50",
        color: "white",
        width: 32,
        height: 32,
        "&:hover": {
            backgroundColor: "#45a049",
        },
    },
    tableHeader: {
        backgroundColor: "transparent",
        "& th > div": {
            fontSize: "12px",
            fontWeight: 700,
            backgroundColor: "#424242",
            height: "32px",
            letterSpacing: "-0.25px",
            color: "#FFFFFF",
            lineHeight: "12px",
            display: "flex",
            alignItems: "center",
            padding: "10px 15px",
        },
        "& .MuiTableCell-head": {
            padding: "0 0 15px",
        },
        "& .MuiTableSortLabel-root": {
            color: "white",
            "&:hover": {
                color: "#ccc",
            },
            "&.MuiTableSortLabel-active": {
                color: "white",
            },
        },
        "& .MuiTableSortLabel-icon": {
            color: "white",
        },
    },
    tableRow: {
        "&:hover": {
            backgroundColor: "#e0e0e0",
        },
    },
    tableRowEven: {
        backgroundColor: "#f5f5f5",
    },
    tableRowOdd: {
        backgroundColor: "#fff",
        // "&:hover": {
        //     backgroundColor: "#e0e0e0",
        // },
    },
    customerName: {
        fontWeight: 500,
        color: theme.palette.text.primary,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    lockIcon: {
        fontSize: "18px",
        color: "#555",
    },
    reportBtn: {
        color: "#fff",
        opacity: 1,
        padding: "11px 20px",
        fontSize: "14px",
        minWidth: "50px",
        background: "#449B23",
        fontWeight: "normal",
        lineHeight: "15px",
        borderRadius: "30px",
        letterSpacing: "-0.21px",
        height: "min-content",
        marginTop: "20px",
        "&:hover": {
            background: "#449B23",
        },
    },
    paginationContainer: {
        backgroundColor: "#424242",
        color: "white",
        "& .MuiTablePagination-root": {
            color: "white",
        },
        "& .MuiIconButton-root": {
            color: "white",
            "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
        },
        "& .MuiSelect-root": {
            color: "white",
        },
        "& .MuiSelect-icon": {
            color: "white",
        },
    },
    lockCol: {
        width: "40px",
        textAlign: "center",
        padding: "0 8px",
    },
    [theme.breakpoints.down("md")]: {
        filtersContainer: {
            gridTemplateColumns: "1fr 1fr 1fr",
        },
    },
    [theme.breakpoints.down("sm")]: {
        root: {
            padding: "16px 16px 55px",
        },
        filtersContainer: {
            gridTemplateColumns: "1fr 1fr",
        },
    },
}));
